import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { App as CapApp } from "@capacitor/app";
import { SplashScreen } from "@capacitor/splash-screen";
import { StatusBar, Style } from "@capacitor/status-bar";
import { Haptics, ImpactStyle } from "@capacitor/haptics";
import { isNative, isIOS, pathFromDeepLink, openExternal, isExternalHref } from "@/lib/native";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import { initPush, teardownPush } from "@/lib/push";

export default function NativeBridge() {
  const nav = useNavigate();
  const { user } = useAuth();

  useEffect(() => {
    if (!isNative || !user?.id) return;
    initPush({ userId: user.id, navigate: nav, onForeground: (n) => toast(n.title || "ANGOLAUK+", { description: n.body }) }).catch(() => {});
    return () => { teardownPush(); };
  }, [user?.id, nav]);

  useEffect(() => {
    if (!isNative) return;
    let urlSub, backSub;
    (async () => {
      try {
        await StatusBar.setStyle({ style: Style.Dark });
        if (!isIOS) await StatusBar.setBackgroundColor({ color: "#000000" });
      } catch {}
      urlSub = await CapApp.addListener("appUrlOpen", ({ url }) => {
        const path = pathFromDeepLink(url);
        if (path) nav(path);
      });
      backSub = await CapApp.addListener("backButton", ({ canGoBack }) => {
        if (canGoBack && window.location.pathname !== "/") window.history.back();
        else CapApp.exitApp();
      });
      const launch = await CapApp.getLaunchUrl();
      if (launch?.url) {
        const path = pathFromDeepLink(launch.url);
        if (path && path !== "/") nav(path, { replace: true });
      }
      await SplashScreen.hide({ fadeOutDuration: 250 });
    })();
    return () => { urlSub?.remove(); backSub?.remove(); };
  }, [nav]);

  useEffect(() => {
    if (!isNative) return;
    const onClick = (e) => {
      const a = e.target.closest?.("a[href]");
      if (!a) return;
      const href = a.getAttribute("href");
      if (isExternalHref(href)) {
        e.preventDefault();
        openExternal(href);
      } else if (a.closest("nav[data-testid='bottom-nav']")) {
        Haptics.impact({ style: ImpactStyle.Light }).catch(() => {});
      }
    };
    document.addEventListener("click", onClick, true);
    return () => document.removeEventListener("click", onClick, true);
  }, []);

  return null;
}
